module.exports = __webpack_public_path__ + "img/learner-quiz-Monarch Butterfly.90511394.png";